module.exports = __webpack_public_path__ + "static/media/icon.f8537519.png";